<template>
    <el-main class="order-container" ref="company-container">
        <div class="order-content">
            <div class="handle-box">
                <div class="handle-left">
                    <el-input v-model="query.keyword" clearable class="search-input" placeholder="手机号 / 姓名"></el-input>
                    <el-date-picker style="margin-right:10px" class="date-picker" v-model="query.time" type="daterange"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        clearable></el-date-picker>

                    <el-input-number style="width:160px" v-model="start" size="small" :min="1" :max="300" clearable
                        placeholder="通话开始时间" controls-position="right"></el-input-number>
                    <span class="segment">至</span>
                    <el-input-number style="width:160px" v-model="end" size="small" :min="1" :max="300" clearable
                        placeholder="通话结束时间" controls-position="right"></el-input-number>
                    <el-button type="primary" class="search ml8" @click="doSearch" v-preventReClick>搜索</el-button>
                </div>
            </div>

            <div class="order-detail">
                <el-table class="chart-data-table" :height="tableHeight" :data="tableData" highdivght-current-row
                    ref='phonerecord' v-loading="loading" style="width: 100%">
                    <el-table-column prop="create_time" label="日期" adivgn="center">
                    </el-table-column>
                    <el-table-column prop="realname" label="操作者" adivgn="center"></el-table-column>
                    <el-table-column width="220" label="操作记录">
                        <template slot-scope="scope">
                            <div class="record-divst" v-if="scope.row.timeline_type=='CALL'">
                                <div class="record-header">进行电话沟通</div>
                                <div class="record-div" v-if="scope.row.duration!=0">
                                    <div class="record-title">录音: <el-link class="ellink" type="success" target="_blank"
                                            :href="scope.row.record_url">查看</el-link></div>
                                </div>
                                <div class="record-div" v-if="scope.row.duration">
                                    <div class="record-title">通话时长:{{scope.row.duration}}</div>
                                </div>
                                <div class="record-div" v-if="scope.row.tip_name">
                                    <div class="record-title">小标签:{{scope.row.tip_name}}</div>
                                </div>
                            </div>
                            <div class="record-divst" v-if="scope.row.timeline_type=='REMARK'">
                                <div v-if="scope.row.remark_type ==1">
                                    <div class="record-header">添加客户备注语音</div>
                                    <div class="record-div" v-if="scope.row.duration">
                                        <div class="record-title">通话时长:{{scope.row.duration}}</div>
                                    </div>
                                    <div class="record-div" v-if="scope.row.duration!=0">
                                        <div class="record-title">语音URL: <el-link class="ellink" type="success"
                                                target="_blank" :href="scope.row.record_url">查看</el-link></div>
                                    </div>
                                </div>
                                <div v-if="scope.row.remark_type ==0">
                                    <div class="record-header">添加客户备注</div>
                                    <div class="record-div">
                                        <div class="record-title">添加客户备注:{{scope.row.remark}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="record-divst" v-if="scope.row.timeline_type=='MODIFY'">
                                <div class="record-header" v-if="scope.row.modify_type=='0'">添加客户</div>
                                <div class="record-header" v-if="scope.row.modify_type=='1'">修改客户</div>
                                <div class="record-header" v-if="scope.row.modify_type=='2'">删除客户</div>
                                <div class="record-header" v-if="scope.row.modify_type=='3'">变更跟进人</div>

                                <div class="record-header" v-if="scope.row.modify_type=='4'">添加协作人</div>
                                <div class="record-header" v-if="scope.row.modify_type=='13'">添加拜访记录</div>
                                <div class="record-header" v-if="scope.row.modify_type=='8'">变更协作人</div>
                                <div class="record-header" v-if="scope.row.modify_type=='22'">触发公海规则回收</div>
                                <div class="record-div">
                                    <div class="record-title" v-for="(item ,index) in scope.row.content" :key="index">
                                        {{item}}</div>
                                </div>
                            </div>
                            <div class="record-divst" v-if="scope.row.timeline_type=='SMS'">
                                <div v-if="scope.row.type=='0'">
                                    <div class="record-header">微信收消息</div>
                                    <div class="record-div" v-if="scope.row.duration">
                                        <div class="record-title">通话时长:{{scope.row.duration}}</div>
                                    </div>
                                    <div class="record-div" v-if="scope.row.duration!=0">
                                        <div class="record-title">语音URL: <el-link class="ellink" type="success"
                                                target="_blank" :href="scope.row.record_url">查看</el-link></div>
                                    </div>
                                </div>
                                <div v-if="scope.row.type=='1'">
                                    <div class="record-header">微信发消息</div>
                                    <div class="record-div" v-if="scope.row.duration">
                                        <div class="record-title">通话时长:{{scope.row.duration}}</div>
                                    </div>
                                    <div class="record-div" v-if="scope.row.duration!=0">
                                        <div class="record-title">语音URL: <el-link class="ellink" type="success"
                                                target="_blank" :href="scope.row.record_url">查看</el-link></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="footer-box">
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="pagination.page" :page-size="pagination.limit" :page-sizes="[5, 10, 15, 20, 50]"
                        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
                </div>
            </div>
        </div>
    </el-main>
</template>

<script>
import { preventReClick } from '@/utils/preventReClick';
Vue.use(preventReClick);
import * as api from '@/api/module'
import Vue from 'vue';
const query = {
    keyword: '',
    time: [],
    duration: [],
}
export default {
    namespaced: true,
    name: "BrandIndex",
    components: {

    },
    data() {
        let tableHeight = window.innerHeight - 239;
        return {

            tableHeight: tableHeight,
            // 搜索
            query: Object.assign({}, query),
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            start: undefined,
            end: undefined,
            // 列表
            tableData: [],
            loading: false
        };
    },
    created() {
        this.getTableData();

    },
    methods: {
        //云客电话记录
        getTableData() {
            let _this = this;
            _this.loading = true;
            let query = _this.query;
            let start = this.start == null ? '' : this.start
            let end = this.end == null ? '' : this.end
            let duration = [start, end]
            if (duration) {
                _this.query.duration = duration
            }
            query['pagination'] = this.pagination;
            api.callList(_this.query).then(res => {
                if (res.code == 200) {
                    _this.loading = false;
                    let getTableData = res.data.data
                    this.tableData = getTableData
                    this.pagination = res.data.pagination;
                }
            })
                .catch(err => {
                    console.log(err);
                });
        },

        // 搜索
        doSearch() {
            this.pagination.page = 1
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },

    }
};
</script>

<style lang="less">
@import url('@/assets/css/order.less');
.ellink {
    vertical-align: 0;
}
.segment {
    display: inline-block;
    line-height: 30px;
    margin: 0 10px;
}
.company-container {
    height: 100%;

    .order-content {
        padding: 0;
        height: 100%;

        .order-head {
            margin: 0;
            padding: 0 0 12px 0;
        }

        .order-btn {
            padding: 8px 0;
        }

        .order-detail {
            padding-top: 0;
        }
    }
}

.footer-box {
    display: flex;
    align-items: center;
    padding-top: 12px;

    .toolBar {
        padding: 0;
        flex: 0 15%;
    }

    .pagination {
        flex: 1;
        text-align: end;
        margin: 0;
    }
}
</style>
